(function () {
    const PAGE_SIZE = 6;
    let currentPage = 1;
    let currentFilter = 'all';

    function initReviewsSection() {
      const section = document.getElementById('ProductReviewsSection');
      if (!section) return;

      const list = section.querySelector('.rv-list');
      const moreTpl = document.getElementById('ReviewsMoreTemplate');
      const cards = Array.from(section.querySelectorAll('.rv-list .review-card'))
        .concat(moreTpl ? Array.from(moreTpl.content.querySelectorAll('.review-card')) : []);
      if (!cards.length) return;

      // Move the remaining reviews into the page the first time one of them is needed
      function ensureAllCardsInPage() {
        if (moreTpl && moreTpl.content.childElementCount) {
          list.insertBefore(moreTpl.content, moreTpl);
        }
      }
      // Show highest-rated reviews first (stable sort keeps the original order within the same rating)
      const starCount = c => c.querySelectorAll('.review-stars svg').length - c.querySelectorAll('.review-stars svg.star-empty').length;
      cards.sort((a, b) => starCount(b) - starCount(a));
      ensureAllCardsInPage();
      cards.forEach(c => list.insertBefore(c, moreTpl || null));

      // Dynamically tag reviews with data-attributes for filtering by parsing metadata-tags
      cards.forEach(card => {
        let gender = 'other';
        let scalp = 'other';
        let duration = 'other';

        const metaTags = card.querySelectorAll('.meta-tag');
        metaTags.forEach(tag => {
          const text = tag.textContent.toLowerCase();
          if (text.includes('gender:')) {
            if (text.includes('female') || text.includes('woman')) gender = 'woman';
            else if (text.includes('male') || text.includes('man')) gender = 'man';
          }
          if (text.includes('skin:') || text.includes('scalp:')) {
            if (text.includes('oily')) scalp = 'oily';
            else if (text.includes('dry') || text.includes('sensitive')) scalp = 'dry-sensitive';
          }
          if (text.includes('duration:')) {
            if (text.includes('6 months') || text.includes('1 year') || text.includes('3 years') || text.includes('2 years')) {
              duration = '6-months';
            }
          }
        });

        // Support detection extensions using content clues for 100% accuracy matching
        const contentText = card.querySelector('.review-content')?.textContent.toLowerCase() || '';
        const authorText = card.querySelector('.review-author')?.textContent.toLowerCase() || '';
        const headingText = card.querySelector('.review-heading')?.textContent.toLowerCase() || '';

        // Oily scalp detection extensions
        if (scalp === 'other') {
          if (contentText.includes('oily') || headingText.includes('oily') || authorText.includes('kou1') || contentText.includes('flatness') || contentText.includes('flat')) {
            scalp = 'oily';
          } else if (contentText.includes('dry') || contentText.includes('sensitive') || authorText.includes('samurai') || contentText.includes('dryness')) {
            scalp = 'dry-sensitive';
          }
        }

        // Man/Woman detection extensions
        if (gender === 'other') {
          if (authorText.includes('takeshi') || authorText.includes('kou1') || authorText.includes('ryo') || authorText.includes('gissy') || authorText.includes('samurai') || contentText.includes('husband')) {
            gender = 'man';
          } else if (authorText.includes('junko') || authorText.includes('non') || authorText.includes('hitorin') || authorText.includes('mari') || authorText.includes('marin')) {
            gender = 'woman';
          }
        }

        // Duration detection extensions
        if (duration === 'other') {
          if (contentText.includes('6 months') || contentText.includes('two years') || contentText.includes('three years') || contentText.includes('long time')) {
            duration = '6-months';
          }
        }

        card.setAttribute('data-gender', gender);
        card.setAttribute('data-scalp', scalp);
        card.setAttribute('data-duration', duration);

        // --- CONSOLIDATE FOOTER ---
        // Get original author name
        const originalAuthorEl = card.querySelector('.review-card-header .review-author');
        let authorName = originalAuthorEl ? originalAuthorEl.textContent.trim() : 'Anonymous';
        let initial = 'A.';
        if (authorName.toLowerCase() !== 'anonymous' && authorName.length > 0) {
          // If name has characters, take the first non-special character
          const firstChar = authorName.replace(/[^a-zA-Z0-9]/g, '').charAt(0);
          initial = (firstChar || authorName.charAt(0)).toUpperCase() + '.';
        }

        // Create unified footer elements list
        const footerParts = [];

        // 1. Author Initial
        footerParts.push(`<span class="review-author">${initial}</span>`);

        // 2. Gender
        if (gender === 'man') {
          footerParts.push('Man');
        } else if (gender === 'woman') {
          footerParts.push('Woman');
        }

        // 3. Scalp / Skin Type
        if (scalp === 'oily') {
          footerParts.push('Oily scalp');
        } else if (scalp === 'dry-sensitive') {
          footerParts.push('Dry or sensitive scalp');
        } else {
          // Fallback to original skin tag if present
          let skinTag = '';
          metaTags.forEach(tag => {
            if (tag.textContent.toLowerCase().includes('skin:')) {
              const labelEl = tag.querySelector('.meta-label');
              skinTag = tag.textContent.replace(labelEl ? labelEl.textContent : '', '').trim();
            }
          });
          if (skinTag) {
            footerParts.push(skinTag);
          }
        }

        // 4. Duration
        if (duration === '6-months') {
          footerParts.push('Using 6+ months');
        }

        // 5. Verified purchase (badge)
        const badgeEl = card.querySelector('.review-badge');
        if (badgeEl && badgeEl.textContent.toLowerCase().includes('verified')) {
          footerParts.push('Verified purchase');
        }

        // Create the footer div
        const footerDiv = document.createElement('div');
        footerDiv.className = 'review-footer';
        footerDiv.innerHTML = footerParts.join(' <span class="review-meta-dot">&bull;</span> ');

        card.appendChild(footerDiv);
      });

      const filtersContainer = document.getElementById('ReviewsFilters');
      const paginationContainer = document.getElementById('ReviewsPagination');
      const numbersContainer = document.getElementById('PaginationNumbers');
      const prevBtn = document.getElementById('PrevPageBtn');
      const nextBtn = document.getElementById('NextPageBtn');

      if (!filtersContainer || !paginationContainer || !numbersContainer || !prevBtn || !nextBtn) return;

      // Function to get currently active filtered cards
      function getFilteredCards() {
        if (currentFilter === 'all') {
          return cards;
        } else if (currentFilter === 'oily') {
          return cards.filter(card => card.getAttribute('data-scalp') === 'oily');
        } else if (currentFilter === 'dry-sensitive') {
          return cards.filter(card => card.getAttribute('data-scalp') === 'dry-sensitive');
        } else if (currentFilter === 'duration-6') {
          return cards.filter(card => card.getAttribute('data-duration') === '6-months');
        } else if (currentFilter === 'man') {
          return cards.filter(card => card.getAttribute('data-gender') === 'man');
        } else if (currentFilter === 'woman') {
          return cards.filter(card => card.getAttribute('data-gender') === 'woman');
        }
        return cards;
      }

      function updatePagination() {
        const filteredCards = getFilteredCards();
        const totalPages = Math.ceil(filteredCards.length / PAGE_SIZE) || 1;

        // Reset page if it exceeds total pages
        if (currentPage > totalPages) {
          currentPage = totalPages;
        }

        // Generate page number buttons dynamically
        numbersContainer.innerHTML = '';
        for (let i = 1; i <= totalPages; i++) {
          const btn = document.createElement('button');
          btn.className = 'pagination-btn num-btn';
          if (i === currentPage) btn.classList.add('active');
          btn.textContent = i;
          btn.setAttribute('data-page', i);
          btn.addEventListener('click', function () {
            showPage(i);
            scrollToSection();
          });
          numbersContainer.appendChild(btn);
        }

        showPage(currentPage);
      }

      function showPage(pageNumber) {
        currentPage = pageNumber;
        const filteredCards = getFilteredCards();
        const totalPages = Math.ceil(filteredCards.length / PAGE_SIZE) || 1;
        const startIndex = (pageNumber - 1) * PAGE_SIZE;
        const endIndex = startIndex + PAGE_SIZE;

        // Hide all cards first
        cards.forEach(card => {
          card.classList.remove('show');
          card.style.display = 'none';
        });

        // Show filtered cards in current page range
        const pageCards = filteredCards.slice(startIndex, endIndex);
        if (pageCards.some(card => !card.isConnected)) ensureAllCardsInPage();
        pageCards.forEach(card => { card.style.display = 'flex'; });
        // Add the animation class on the next frame (one layout pass instead of one per card)
        requestAnimationFrame(() => {
          pageCards.forEach(card => card.classList.add('show'));
        });

        // Update active class on number buttons
        const numBtns = numbersContainer.querySelectorAll('.num-btn');
        numBtns.forEach(btn => {
          if (parseInt(btn.getAttribute('data-page')) === pageNumber) {
            btn.classList.add('active');
          } else {
            btn.classList.remove('active');
          }
        });

        // Toggle disabled states
        prevBtn.disabled = (currentPage === 1);
        nextBtn.disabled = (currentPage === totalPages);

        // Hide pagination completely if total pages <= 1
        if (totalPages <= 1) {
          paginationContainer.style.display = 'none';
        } else {
          paginationContainer.style.display = 'flex';
        }
      }

      function scrollToSection() {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Filter Pill click handlers
      const filterBtns = filtersContainer.querySelectorAll('.filter-btn');
      filterBtns.forEach(btn => {
        btn.addEventListener('click', function () {
          filterBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          currentFilter = btn.getAttribute('data-filter');
          currentPage = 1; // Reset to page 1 on filter change
          updatePagination();
        });
      });

      // Event listeners for Prev / Next
      prevBtn.addEventListener('click', function () {
        if (currentPage > 1) {
          showPage(currentPage - 1);
          scrollToSection();
        }
      });

      nextBtn.addEventListener('click', function () {
        const filteredCards = getFilteredCards();
        const totalPages = Math.ceil(filteredCards.length / PAGE_SIZE) || 1;
        if (currentPage < totalPages) {
          showPage(currentPage + 1);
          scrollToSection();
        }
      });

      // Initial execution
      updatePagination();
    }

    // Run on immediate DOM load or dynamic state refresh
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initReviewsSection);
    } else {
      initReviewsSection();
    }

    // Function to dynamically sync the review count to match the 51 published reviews
    function fakeReviewsCount() {
      const walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
      let node;
      while (node = walk.nextNode()) {
        const text = node.nodeValue;
        if (/(2|20|35|50)\s+Reviews/i.test(text)) {
          node.nodeValue = text.replace(/(2|20|35|50)\s+Reviews/gi, '51 Reviews');
        } else if (/(2|20|35|50)\s+reviews/i.test(text)) {
          node.nodeValue = text.replace(/(2|20|35|50)\s+reviews/gi, '51 reviews');
        }
      }

      const elements = document.querySelectorAll('.ruk_rating_snippet, [class*="rating-snippet"], [class*="RatingSnippet"], .jdgm-prev-badge__text, .rating-count, .product-trust-bar__text');
      elements.forEach(el => {
        if (el.textContent) {
          el.textContent = el.textContent
            .replace(/\b(2|20|35|50)\s+Reviews\b/gi, '51 Reviews')
            .replace(/\b(2|20|35|50)\s+reviews\b/gi, '51 reviews')
            .replace(/\((2|20|35|50)\)/g, '(51)');
        }
      });
    }

    // Run once now and once after everything has loaded (was every 250 ms for ~8 s,
    // walking every text node on the page each time).
    fakeReviewsCount();
    window.addEventListener('load', function () {
      setTimeout(fakeReviewsCount, 1500);
    });
  })();
